"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FORMSERVICE_MAPPER = exports.TypeDropFormMapper = exports.FORM_DATA_MAPPER = void 0;
exports.FORM_DATA_MAPPER = {
    label: "label",
    type: "type",
    name: "name",
    fileTypes: "filetype",
    isRequired: "mandatory",
    options: "options",
    uniqueKey: "uniqueKey",
    placeholder: "placeholder",
    charLimit: "charLimit",
    validations: "validation",
    id: "id",
    _id: "_id", // For items from existing forms
    value: "value",
    question: "question", // For items from existing forms
    order: "order",
    formInputId: "formInputId", // For items from existing forms
    formId: "formId", // For items from existing forms
    isHidden: "isHidden",
    formInput: "formInput", // For items from existing forms
    // New property for visibility
};
exports.TypeDropFormMapper = {
    paragraph: "textarea",
    text: "text",
    short_answer: "text",
    // 'email' ,
    // 'password' ,
    phone_number: "tel",
    //  'tel' ,
    //  'url' ,
    //  'textarea',
    multiple_choice: "radio",
    check_boxes: "checkbox",
    drop_down: "select",
    file_upload: "file",
    number: "number",
    //      'date' ,
    _time: "time",
    _date: "datetime-local",
};
exports.FORMSERVICE_MAPPER = {
    label: "question",
    placeholder: "placeholder",
};
